export const CheckIcon = ({ size = 16, color = 'white' }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M4 9.06572L6.4 11L12 5' stroke={color} strokeLinecap='square' strokeLinejoin='round' />
  </svg>
);

export const CheckIconTight = ({ size = 16, color = 'white' }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2 10.4539L3.95 12.227L5.9 14L10.45 8.5L15 3' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
